import Typography from "@mui/material/Typography";

import React from "react";

interface TextoConLabelProps {
  label: string | React.ReactNode;
  texto: string;
  align?: "left" | "right" | "center";
  labelColor?: string;
  textColor?: string;
  negrita?: boolean;
  error?: string;
}

const TextoConLabel: React.FC<TextoConLabelProps> = ({
  label,
  texto,
  align = "left",
  labelColor = "black",
  textColor = "black",
  negrita = false,
  error
}) => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", color: labelColor }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: textColor,
          textAlign: align,
          fontWeight: negrita ? "bold" : "normal"
        }}
      >
        {texto}
      </Typography>
      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}
    </>
  );
};

export default TextoConLabel;
